import React from "react"
import { useOutletContext } from "react-router-dom"
import { App, Input, Space, Typography } from "antd"

import { confirmAction } from "@components/Page"
import { useAppContext } from "@components/AppContext"
import {
  enableOrganizationOperation,
  disableOrganizationOperation
} from "@api/services/organizations"

const { Text } = Typography
const { TextArea } = Input

const ENABLE = "ENABLE"
const DISABLE = "DISABLE"

const LABEL_ENTITY = "Organization"
const LABEL_ENABLE = "Enable"
const LABEL_DISABLE = "Disable"

let disableReason = ""
const onChange = ({ currentTarget }) => {
  disableReason = currentTarget.value
}


const useActions = (organization, table, setOrganization) => {
  const { modal } = App.useApp()
  const { updateUser } = useOutletContext()
  const { authenticatedRequest, showSuccessMessage, authorizeOrganizationIdentity } = useAppContext()

  if (!organization) {
    return { enableOrganization: () => {}, disableOrganization: () => {} }
  }

  const { id } = organization

  const ACTIONS_MAP = {
    [DISABLE]: {
      operation: disableOrganizationOperation,
      type: "danger",
      title: `${LABEL_DISABLE} ${LABEL_ENTITY}`,
      action: LABEL_DISABLE,
      success: `${LABEL_ENTITY} is disabled`,
      content: (
        <Space
          direction="vertical"
          style={{ width: "100%"}}
        >
          <Text>{`${LABEL_ENTITY} becomes disabled. Its users won't be able to access the portal.`}</Text>
          <TextArea
            rows={4}
            onChange={onChange}
            placeholder="Specify the reason..."
            maxLength={128}
          />
        </Space>
      ),
    },
    [ENABLE]: {
      operation: enableOrganizationOperation,
      type: "default",
      title: `${LABEL_ENABLE} ${LABEL_ENTITY}`,
      action: LABEL_ENABLE,
      success: `${LABEL_ENTITY} is enabled`,
      content: `${LABEL_ENTITY} becomes enabled. Its users could access the portal again.`,
    }
  }

  const action = actionName =>
    confirmAction(
      modal,
      ACTIONS_MAP[actionName].action,
      ACTIONS_MAP[actionName].title,
      ACTIONS_MAP[actionName].content,
      async () => {
        const { operation } = ACTIONS_MAP[actionName]
        const parameters = { id }

        const isDisable = actionName === DISABLE

        if (isDisable) {
          parameters.mutation = { disableReason }
        }

        return authenticatedRequest(operation, parameters)
          .then(({ data }) => {
            setOrganization(data)
            updateUser(data)
          })
          .then(() => disableReason = "")
          .then(() => {
            showSuccessMessage(ACTIONS_MAP[actionName].success)
          })
          .then(() => authorizeOrganizationIdentity())
          .then(() => table.current.indexItems())
      },
      ACTIONS_MAP[actionName].type,
    )

  const enableOrganization = () => action(ENABLE)

  const disableOrganization = () => action(DISABLE)

  return {
    enableOrganization,
    disableOrganization,
  }
}

export default useActions
